import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { ScheduleType } from 'types/schedule'
import { DaysOfWeek } from 'lib/daysOfWeek'
import { fetchSchedulesAction } from 'reducks/schedule/actions'
import { mergeSchedules } from 'reducks/schedule/operations'

const fetchSchedulesOfBread = (storeRef: FirebaseDocRefType, breadRef: FirebaseDocRefType, type?: string) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const manufacturerRef = getState().auth.manufacturer_ref

    let query = storeRef.collection('store_schedules').where('bread_ref', '==', breadRef)

    if (typeof type !== 'undefined') {
      query = query.where('type', '==', type)
    }
    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }

    const schedules: ScheduleType[] = await query
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        return mergeSchedules(snapshots)
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    const daysOfWeek = new DaysOfWeek()
    schedules.sort((a, b) => {
      return daysOfWeek.getEarlyOrder(a.days_of_week) < daysOfWeek.getEarlyOrder(b.days_of_week) ? -1 : 1
    })
    dispatch(fetchSchedulesAction(schedules))
  }
}

export default fetchSchedulesOfBread
